<template>
  <el-dialog
    :title="this.type != 'new' ? $t('app.edit') : $t('app.new')"
    :visible.sync="dialogVisible"
    width="700px"
  >
    <el-input
      v-model="typeCode"
      size="small"
      v-if="this.type != 'new'"
      disabled
      style="margin-bottom: 20px; width: 100%"
      placeholder="字典項類型編碼"
    >
    </el-input>
    <el-input
      v-model="code"
      size="small"
      :disabled="this.type != 'new'"
      style="margin-bottom: 20px; width: 100%"
      placeholder="字典項編碼"
    >
    </el-input>
    <el-input
      size="small"
      style="margin-bottom: 20px; width: 100%"
      v-model="name"
      placeholder="字典項名稱"
    >
    </el-input>
    <el-select
      v-model="isUse"
      size="small"
      style="margin-bottom: 20px; width: 100%"
      :placeholder="$t('app.validation.select') + $t('app.enable')"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-input
      size="small"
      style="margin-bottom: 20px"
      v-model="description"
      :placeholder="$t('app.description')"
    >
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { addParent, update } from "@/api/systemManagement/dictionaryManagement";
export default {
  data() {
    return {
      code: "",
      typeCode: "",
      name: "",
      isUse: null,
      description: "",
      options: [
        {
          value: true,
          label: this.$t("app.isUse"),
        },
        {
          value: false,
          label: this.$t("app.disable"),
        },
      ],

      loading: false,
      dialogVisible: false,
      index: "",
      type: "",
    };
  },
  methods: {
    edit(index, row) {
      this.dialogVisible = true;
      this.code = row.code;
      this.typeCode = row.typeCode;
      this.name = row.name;
      this.isUse = row.enable;
      this.description = row.description;
      this.index = index;
      (this.sort = row.sort), (this.type = "edit");
    },
    add() {
      this.dialogVisible = true;
      this.type = "new";
      this.code = "";
      this.name = "";
      this.index = "";
      this.isUse = null;
      this.description = "";
      this.sort = "99";
    },
    handleClose() {
      this.$confirm(
        (this.type === "edit"
          ? this.$t("app.confirmModification")
          : this.$t("app.confirmAdd")) + "?"
      ).then(() => {
        this.loading = true;
        if (this.type === "edit") {
          update({
            DictTypeCode: this.typeCode,
            DictCode: this.code,
            DictText: this.name,
            Description: this.description,
            IsUse: this.isUse,
            SortNumber: this.sort,
          })
            .then(() => {
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          addParent({
            DictCode: this.code,
            DictText: this.name,
            Description: this.description,
            IsUse: this.isUse,
            SortNumber: this.sort,
          })
            .then(() => {
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    success() {
      this.loading = false;
      this.dialogVisible = false;
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.$emit("handleSuccess");
    },
  },
};
</script>
